import ChevronImage from "@assets/video_widget/Chevron.webp";
import ArticleCard from "@blocks/Card/ArticleCard";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import { Fragment, ReactElement } from "react";
import { Link } from "react-router";

// News Grid Component
export const Tm90Articles = ({
  articles,
  tagAlias,
}: {
  articles?: ProcessedArticleData[];
  tagAlias: string;
}): ReactElement => {
  return (
    <div className="bg-white py-12">
      <div className="max-w-6xl mx-auto px-4">
        <Link reloadDocument to={tagAlias} target="_blank">
          <div className="text-red-100 text-2.5md font-bold mt-5 hover:underline hover:cursor-pointer">
            TM90 செய்திகள்
            <img
              alt="toggle-button-chevie"
              height={26}
              width={26}
              className="pl-100 inline"
              src={ChevronImage}
            />
          </div>
        </Link>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {articles &&
            [...articles].map((section) => (
              <Fragment key={section.id}>
                <ArticleCard
                  key={section.id}
                  displayWidth={360}
                  displayHeight={240}
                  elements={{ hasParagraph: false, hasDate: true }}
                  {...section}
                  overrideStyle={{
                    cardWrapper: "flex-col border-0",
                    titleStyle:
                      "text-gray-100 text-xs font-medium leading-[160%] hover:text-gray-100 hover:underline",
                    imageWrapperStyle: "w-full sm:w-full",
                    contentWrapper: "gap-0",
                    titleWrapper: "pr-1",
                    imageStyle: "w-full",
                  }}
                  refMedium={"tm90"}
                />
              </Fragment>
            ))}
        </div>
      </div>
    </div>
  );
};
